<!-- Centered in the message list at every chat window width, like the welcome card of an empty chat. -->
<div
  class="mx-auto flex w-[340px] items-center gap-3 overflow-hidden rounded-lg bg-assistant-welcome p-2"
  data-testid="assistant-system-message-root"
>
  <svg-icon key="px-24-ai-2" size="md" class="shrink-0 text-states-purple-dark"></svg-icon>
  <div class="flex min-w-0 flex-1 flex-col gap-0.5 text-start">
    <span class="typo-h7-semibold text-text-black">{{ 'assistant_chat_window_system_message_sender' | translate }}</span>
    <span class="typo-h7-book text-text-black">{{ 'assistant_chat_window_system_message_body' | translate }}</span>
  </div>
</div>
